import { getListOfSenderId } from "../types/sender_id_list_types";

const initState = {
  data: ["senderId"],
  count: 0,
  loading: false,
  error: null,
  cellLoading: null,
};

export default function senderIdListReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfSenderId.GET_LIST_OF_SENDER_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfSenderId.GET_LIST_OF_SENDER_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        count: action.payload.count,
        error: null,
      };
    case getListOfSenderId.GET_LIST_OF_SENDER_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
